import { enumToStaticValue } from '@/utils'
import { ItemOriginType } from './itemOriginType'

export default enumToStaticValue(ItemOriginType, 'item-origin-type')
